import {documentToReactComponents} from '@contentful/rich-text-react-renderer'
import {Document} from '@contentful/rich-text-types'
import {FC} from 'react'

import {ContentCard, ContentCardImageSize} from '@/components/common/content/ContentCard'
import {TextVariant} from '@/components/common/content/Text'
import {GUIDE_SIDEBAR_WIDTH, HEADER_HEIGHT_DESKTOP} from '@/theme/sizing'
import {theme} from '@/theme/theme'
import {withSequentialHeadingLevels} from '@/utils/contentful/headingLevels'
import {
  MOBILE_SCREENSIZE,
  TABLET_SCREENSIZE,
  USER_TABLET_SCREENSIZE,
} from '@/utils/styles/breakpoints'
import {AnalyticsTrackedEvent} from '@/utils/tracking/types'

import {options} from '../blog/detail/styledBlogOptions'
import {ContentsList} from '../contentful/ContentsList'

type GuideContentLayoutProps = {
  guide: Document
  sidebarCards: {
    title: string
    description: string
    imageSrc: string
    imageAlt: string
    imageSize?: ContentCardImageSize
    buttonText: string
    buttonLink: string
    trackedEvent: AnalyticsTrackedEvent
  }[]
}

export const GuideContentLayout: FC<GuideContentLayoutProps> = ({guide, sidebarCards}) => {
  return (
    <>
      <div className="wrapper">
        <div className="content">
          <ContentsList content={guide.content} />
          {documentToReactComponents(withSequentialHeadingLevels(guide), options)}
        </div>
        <div className="sidebar">
          {sidebarCards.map(
            ({
              title,
              description,
              imageSrc,
              imageAlt,
              imageSize,
              buttonLink,
              buttonText,
              trackedEvent,
            }) =>
              title && buttonLink ? (
                <div key={buttonLink} className="card">
                  <ContentCard
                    imageSrc={imageSrc}
                    imageAlt={imageAlt}
                    imageSize={imageSize}
                    title={title}
                    titleTextVariant={TextVariant.h5}
                    description={description}
                    descriptionTextVariant={TextVariant.text16}
                    linkHref={buttonLink}
                    buttonText={buttonText}
                    trackedEvent={trackedEvent}
                    openInNewTab
                  />
                </div>
              ) : null,
          )}
        </div>
      </div>

      <style jsx>{`
        .wrapper {
          display: flex;
          justify-content: space-between;
        }
        .sidebar {
          position: sticky;
          top: calc(${HEADER_HEIGHT_DESKTOP} + ${theme.spacing[4]});
          height: 100%;
          flex: 0 0 ${GUIDE_SIDEBAR_WIDTH};
          max-width: ${GUIDE_SIDEBAR_WIDTH};
          margin-left: ${theme.spacing[7]};
        }
        .card {
          flex: 1;
        }
        .card + .card {
          margin-top: ${theme.spacing[5]};
        }
        @media ${TABLET_SCREENSIZE} {
          .sidebar {
            top: ${theme.spacing[5]};
          }
        }
        @media ${USER_TABLET_SCREENSIZE} {
          .wrapper {
            display: block;
          }
          .sidebar {
            display: flex;
            max-width: inherit;
            margin: ${theme.spacing[6]} auto 0;
          }
          .card + .card {
            margin-top: 0;
            margin-left: ${theme.spacing[5]};
          }
        }
        @media ${MOBILE_SCREENSIZE} {
          .sidebar {
            display: block;
          }
          .card + .card {
            margin-top: ${theme.spacing[4]};
            margin-left: 0;
          }
        }
      `}</style>
    </>
  )
}
